$(document).ready(function () {
  kycount = 0;

  // Loop through each gallery element
  $(".ky_custom_gallery_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper" + kycount);

    // Get necessary data attributes
    var desk_slider = this_item.attr("data-desktop_swiper");
    var mob_slider = this_item.attr("data-mobile_swiper");
    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item = this_item.attr("data-ipad_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    var slider_mode = this_item.attr("data-mode");
    var swiper_arrows = this_item.attr("data-swiper-style-arrow");
    var swiper_style = this_item.attr("data-swiper_style");
    var slider_autoplay = this_item.attr("data-slider-autoplay");
    var slider_center = this_item.attr("data-slider-center");
    var slider_effect = this_item.attr("data-slider-effect");
    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");
    var desktop_offset = this_item.attr("data-desktop-offset");
    var mobile_offset = this_item.attr("data-mobile-offset");
    var ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    var ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    var slider_loop = this_item.attr("data-slider-loop");

    var swiper_navigation = {};
    var swiper_pagination = {};
    var slider_autoplay_start = {};
    var is_slider_loop = slider_loop !== "false"; // Default is true
    var is_slider_center = slider_center !== "false"; // Default is true

    if (swiper_arrows == "true") {
      this_item.append(
        '<div class="swiper-button-next swiper_arrows customswiper_next' +
          kycount +
          '"></div><div class="swiper-button-prev swiper_arrows customswiper_prev' +
          kycount +
          '"></div>'
      );
      swiper_navigation = {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      };
    }

    if (swiper_style == "dots") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
    } else if (swiper_style == "progress_bar") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true,
      };
    } else if (swiper_style == "fraction") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      };
    } else {
      swiper_pagination = {};
    }

    slider_autoplay_start =
      slider_autoplay == "true"
        ? {
            delay: 3500,
            disableOnInteraction: false,
          }
        : {
            delay: 250000000000,
            disableOnInteraction: true,
          };
    var partner_swiper = new Swiper(".customswiper" + kycount, {
      spaceBetween: 0,
      navigation: swiper_navigation,
      effect: slider_effect === "fade" ? "fade" : "",
      pagination: swiper_pagination,
      loop: is_slider_loop,
      autoplay: slider_autoplay_start,
      centeredSlides: is_slider_center,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
  });
  $(".ky_custom_gallery_with_hover_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    this_item.addClass("swiper customswiper" + kycount);

    // Get necessary data attributes
    var desk_slider = this_item.attr("data-desktop_swiper");
    var mob_slider = this_item.attr("data-mobile_swiper");
    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item = this_item.attr("data-ipad_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");
    var slider_mode = this_item.attr("data-mode");
    var swiper_arrows = this_item.attr("data-swiper-style-arrow");
    var swiper_style = this_item.attr("data-swiper_style");
    var slider_autoplay = this_item.attr("data-slider-autoplay");
    var slider_center = this_item.attr("data-slider-center");
    var slider_effect = this_item.attr("data-slider-effect");
    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");
    var desktop_offset = this_item.attr("data-desktop-offset");
    var mobile_offset = this_item.attr("data-mobile-offset");
    var ipad_vertical_offset = this_item.attr("data-ipad-vertical-offset");
    var ipad_horizontal_offset = this_item.attr("data-ipad-horizontal-offset");
    var slider_loop = this_item.attr("data-slider-loop");

    var swiper_navigation = {};
    var swiper_pagination = {};
    var slider_autoplay_start = {};
    var is_slider_loop = slider_loop !== "false"; // Default is true
    var is_slider_center = slider_center !== "false"; // Default is true

    if (swiper_arrows == "true") {
      this_item.append(
        '<div class="swiper-button-next swiper_arrows customswiper_next' +
          kycount +
          '"></div><div class="swiper-button-prev swiper_arrows customswiper_prev' +
          kycount +
          '"></div>'
      );
      swiper_navigation = {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      };
    }

    if (swiper_style == "dots") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      };
    } else if (swiper_style == "progress_bar") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "progressbar",
        clickable: true,
      };
    } else if (swiper_style == "fraction") {
      this_item.append('<div class="swiper-pagination"></div>');
      swiper_pagination = {
        el: ".swiper-pagination",
        type: "fraction",
        clickable: true,
      };
    } else {
      swiper_pagination = {};
    }

    slider_autoplay_start =
      slider_autoplay == "true"
        ? {
            delay: 3500,
            disableOnInteraction: false,
          }
        : {
            delay: 250000000000,
            disableOnInteraction: true,
          };
    var partner_swiper = new Swiper(".customswiper" + kycount, {
      spaceBetween: 0,
      navigation: swiper_navigation,
      effect: slider_effect === "fade" ? "fade" : "",
      pagination: swiper_pagination,
      loop: is_slider_loop,
      autoplay: slider_autoplay_start,
      centeredSlides: is_slider_center,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: mobile_offset,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: ipad_vertical_offset,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: ipad_horizontal_offset,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: desktop_offset,
        },
      },
    });
  });
  $(".ky_custom_testimonial_swiper").each(function () {
    kycount++;
    var this_item = $(this);
    var currentCount = kycount;
    this_item.addClass("swiper customswiper3" + kycount);

    this_item.append(
      '<div class="swiper-button-next swiper_arrows2  customswiper_next' +
        kycount +
        '"></div><div class="swiper-button-prev swiper_arrows2  customswiper_prev' +
        kycount +
        '"></div>'
    );
    this_item.append(
      '<div class="swiper-pagination testimonials_pagination' +
        currentCount +
        '"></div>'
    );

    var desk_item = this_item.attr("data-desktop_items");
    var mob_item = this_item.attr("data-mobile_items");
    var ipad_item_horizontal = this_item.attr("data-ipad_horizontal_items");
    var ipad_item_vertical = this_item.attr("data-ipad_vertical_items");

    var slider_desktop_padding = this_item.attr("data-desktop-padding");
    var slider_ipad_horizontal_padding = this_item.attr(
      "data-ipad-horizontal-padding"
    );
    var slider_ipad_vertical_padding = this_item.attr(
      "data-ipad-vertical-padding"
    );
    var slider_mobile_padding = this_item.attr("data-mobile-padding");

    var partner_swiper = new Swiper(".customswiper3" + kycount, {
      spaceBetween: 0,
      navigation: {
        nextEl: ".customswiper_next" + kycount,
        prevEl: ".customswiper_prev" + kycount,
      },
      pagination: {
        el: ".swiper-pagination.testimonials_pagination" + currentCount,
        type: "bullets",
        clickable: true,
      },
      on: {
        slideChange: function () {
          setTimeout(() => {
            updatePaginationBullets(currentCount);
          }, 50);
        },
        init: function () {
          setTimeout(() => {
            updatePaginationBullets(currentCount);
          }, 50);
        },
      },
      loop: false,
      autoplay: false,
      centeredSlides: false,
      breakpoints: {
        0: {
          slidesPerView: mob_item,
          spaceBetween: slider_mobile_padding,
          slidesOffsetBefore: 10,
        },
        481: {
          slidesPerView: ipad_item_vertical,
          spaceBetween: slider_ipad_vertical_padding,
          slidesOffsetBefore: 20,
        },
        786: {
          slidesPerView: ipad_item_horizontal,
          spaceBetween: slider_ipad_horizontal_padding,
          slidesOffsetBefore: 30,
        },
        1100: {
          slidesPerView: desk_item,
          spaceBetween: slider_desktop_padding,
          slidesOffsetBefore: 30,
        },
      },
    });
    function updatePaginationBullets(count) {
      const bullets = document.querySelectorAll(
        ".testimonials_pagination" + count + " .swiper-pagination-bullet"
      );
      const activeIndex = [...bullets].findIndex((b) =>
        b.classList.contains("swiper-pagination-bullet-active")
      );

      bullets.forEach((bullet, i) => {
        bullet.classList.remove(
          "swiper-pagination-bullet-nearby",
          "swiper-pagination-bullet-far"
        );

        const distance = Math.abs(activeIndex - i);

        if (distance === 1) {
          bullet.classList.add("swiper-pagination-bullet-nearby");
        } else if (distance >= 2) {
          bullet.classList.add("swiper-pagination-bullet-far");
        }
      });
    }
  });
});

$(document).ready(function () {
  // Handle both main nav and drawer click
  $(".annu_item.virtual_appointment, #HeaderDrawer-virtual-appointment").on(
    "click",
    function (e) {
      e.preventDefault();

      // Delay popup open if from drawer
      setTimeout(function () {
        $("body").addClass("popup-open");
        $(".virtual_appointment_pop").fadeIn();
      }, 300); // adjust delay if needed
    }
  );

  // ESC key close
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      $(".virtual_appointment_pop").fadeOut();
      $("body").removeClass("popup-open");
    }
  });

  // Click outside to close
  $(document).on("click", function (e) {
    if (
      $(".virtual_appointment_pop").is(":visible") &&
      $(e.target).closest(".virtual_appointment_pop_inner").length === 0 &&
      !$(e.target).is(".annu_item.virtual_appointment") &&
      !$(e.target).is("#HeaderDrawer-virtual-appointment")
    ) {
      $(".virtual_appointment_pop").fadeOut();
      $("body").removeClass("popup-open");
    }
  });

  // Close btn click
  $(".close_virtual_popup").on("click", function () {
    $(".virtual_appointment_pop").fadeOut();
    $("body").removeClass("popup-open");
  });
});

$(document).ready(function () {
  // Summary click ko disable kar do
  $(".open_grandchild > summary").on("click", function (event) {
    event.preventDefault(); // Default toggle behavior ko roke
  });
});
